// Form Tabs Component - Zeigt verschiedene Formulare als Tabs an

import { cn } from '@/lib/utils';

interface FormTabsProps {
  formIdentifiers: string[];
  selectedForm: string | undefined;
  onSelectForm: (form: string | undefined) => void;
  formCounts?: Record<string, number>;
}

// Formatiert den form_identifier für die Anzeige
function formatFormName(identifier: string): string {
  return identifier
    .split(/[-_]/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export default function FormTabs({
  formIdentifiers,
  selectedForm,
  onSelectForm,
  formCounts,
}: FormTabsProps) {
  if (formIdentifiers.length === 0) return null;

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 mb-6">
      <h3 className="text-sm font-medium text-gray-500 mb-3">📋 Formulare</h3>
      
      <div className="flex flex-wrap gap-2">
        {/* Alle Formulare anzeigen */}
        <button
          onClick={() => onSelectForm(undefined)}
          className={cn(
            'px-4 py-2 rounded-lg text-sm font-medium transition-all',
            !selectedForm
              ? 'bg-blue-600 text-white shadow-md hover:bg-blue-700'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          )}
        >
          Alle Anfragen
          {formCounts && (
            <span className="ml-2 px-2 py-0.5 bg-white/30 rounded-full text-xs">
              {Object.values(formCounts).reduce((a, b) => a + b, 0)}
            </span>
          )}
        </button>
        
        {/* Einzelne Formulare */}
        {formIdentifiers.map((form) => (
          <button
            key={form}
            onClick={() => onSelectForm(form)}
            className={cn(
              'px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center',
              selectedForm === form
                ? 'bg-blue-600 text-white shadow-md hover:bg-blue-700'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            )}
          >
            {formatFormName(form)}
            {formCounts && formCounts[form] !== undefined && (
              <span className={cn(
                'ml-2 px-2 py-0.5 rounded-full text-xs',
                selectedForm === form ? 'bg-white/30' : 'bg-gray-200'
              )}>
                {formCounts[form]}
              </span>
            )}
          </button>
        ))}
      </div>
      
      {formIdentifiers.length > 5 && (
        <p className="mt-3 text-xs text-gray-500">
          💡 Tipp: Verwenden Sie den Filter oben für erweiterte Suchoptionen
        </p>
      )}
    </div>
  );
}
